import { combineReducers } from "redux";
import authReducer from "./auth/authReducer";
import premiumSportsReducer from "./exchangeSports/exchangeSportsReducer";
import betslipReducer from "./betSlip/betSlipReducer";
import commonReducer from "./common/commonReducer";
const rootReducer = combineReducers({
  auth: authReducer,
  sportsBook: premiumSportsReducer,
  common: commonReducer,
  betslip:betslipReducer,
});

export default rootReducer;
